var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M72 52V76C72 78.1217 71.1571 80.1566 69.6569 81.6569C68.1566 83.1571 66.1217 84 64 84H20C17.8783 84 15.8434 83.1571 14.3431 81.6569C12.8429 80.1566 12 78.1217 12 76V32C12 29.8783 12.8429 27.8434 14.3431 26.3431C15.8434 24.8429 17.8783 24 20 24H44M60 12H84M84 12V36M84 12L40 56","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ExternalLink.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
